"use client"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import styles from "../../styles/shared-module-css/SearchBar.module.css"

const SearchBar = ({ searchTerm, onSearchChange, placeholder = "Search...", className = "", width = "220px" }) => (
  <div className={`${styles.search_container} ${className}`} style={{ width }}>
    <input
      type="text"
      placeholder={placeholder}
      value={searchTerm}
      onChange={(e) => onSearchChange(e.target.value)}
      className={styles.search_input}
    />
    <FontAwesomeIcon icon={faSearch} className={styles.search_icon} />
  </div>
)

export default SearchBar
